import { LinearProgress } from "@mui/material";
import { useTheme } from "@mui/system";
import { useAuthContext } from "auth/hooks";
import { RHFAutocomplete } from "components/hook-form";
import useApi from "hooks/useApi";
import { useTranslate } from "locales";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { API_PAGE_LIMIT, VEHICLE_CLASSIFICATION_TYPE } from "utils/constant";


export default function VehicleClassificationTypeAutocomplete({
    name = 'vehicle_classification_type',
    label = '',
    isDisabled = false,
    changeItem,
    isRequired = true,//when require you can't remove value
    multiple = false,
    linkBodyType = false,  //for superadmin list when link classification
    workshop = null,
    workshopType = null,
    sx = {},
    companyId,
    ...other
}) {

    const { t } = useTranslate();
    const theme = useTheme();
    const { user } = useAuthContext()
    const controller = new AbortController();
    const { signal } = controller;
    const [responseList, setResponseList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [loadMore, setLoadMore] = useState(true);
    const [searchWord, setSearchWord] = useState("");
    const [totalItem, setTotalItem] = useState(0);
    const { apiCalling } = useApi();

    const { control, setValue, watch } = useFormContext();

    useEffect(() => {
        async function GetVehicleClassification() {
            try {
                const headers = {
                    companyid: decodeURIComponent(companyId),
                }
                const resCountry = await apiCalling({ url: VEHICLE_CLASSIFICATION_TYPE.get, headers });
                setResponseList(resCountry.data.result);
                setLoading(false);
            } catch (error) {
                console.error(error)
            }
        }
        if (open && !responseList.length) {
            GetVehicleClassification();
        }
        return () => {
            controller.abort();
        };
    }, [open, responseList.length]);


    // useEffect(() => {
    //     setCurrentPage(0)
    //     setResponseList([])
    // }, [searchWord, workshopType])

    const handleListboxScroll = (event) => {
        const listboxNode = event.currentTarget;
        if (listboxNode.scrollTop + listboxNode.clientHeight === listboxNode.scrollHeight && loadMore && !loading && totalItem !== responseList.length) {
            setCurrentPage(currentPage + API_PAGE_LIMIT);
        }
    };

    return (
        <>
            <Controller
                name={name}
                control={control}
                render={({ field, fieldState: { error } }) => (
                    <RHFAutocomplete
                        multiple={multiple}
                        limitTags={2}
                        openOnFocus
                        open={open}
                        onOpen={() => {
                            setOpen(true);
                            setSearchWord('')
                        }}
                        onClose={() => {
                            setOpen(false);
                            setSearchWord('')
                        }}
                        disableClearable={isRequired}
                        name={name}
                        label={label || t('type_')}
                        options={responseList}
                        filterOptions={(options) => options}
                        loading={loading}
                        loadingText={<LinearProgress />}
                        getOptionLabel={(option) => option.classification_type || ""}
                        isOptionEqualToValue={(option, value) => option.vehicle_classification_type_id === value.vehicle_classification_type_id}
                        renderOption={(props, option) => (
                            <li {...props} key={option.vehicle_classification_type_id} style={{ display: "flex", gap: 8 }}>
                                {option.classification_type}
                            </li>
                        )}
                        onChange={(event, newValue) => {
                            changeItem(newValue);
                        }}
                        onInputChange={(event, newValue, reason) => {
                            setSearchWord(newValue)
                        }}
                        ListboxProps={{ onScroll: handleListboxScroll }}
                        disabled={isDisabled}

                        sx={sx}
                        {...other}
                    />
                )}
            />
        </>
    );
}
